import React, { useState } from 'react';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { Checkbox } from 'telstra-ui/components/checkbox/Checkbox';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import { Button } from 'telstra-ui/components/button/Button';
import { TextInput } from 'telstra-ui/components/text-input/TextInput';
import Modal from 'telstra-ui/components/modal/Modal';
import Pagination from 'telstra-ui/components/pagination/Pagination';
import { prepareDropDownOptionsArry } from '../../amp-homepage.actions';
import { formatPhoneNumber } from '../../../ffwd-homepage/ffwd-homepage.actions';
import WirelessFilters from '../wireless-filters/wireless-filters';
import './wireless-table.css';

const WirelessTable = (props) => {
  const {
    authorableContent,
    authorableContent: {
      formFields: {
        wirelessSearchFields,
        wirelessDropdownFields,
        dataTopUpPlans,
      },
      username,
      bulkActionText,
      bulkCancelText,
      bulkUpgradeText,
      itemSelectedText,
      currentPlanName,
      planRecommendation,
      dataAllowanceConsume,
      data,
      gbText,
      cost,
      bulkUpgradeTextPrefix,
      bulkPlanUpgradeTextSuffix,
      paginationNumbers,
      paginationBaseNumber,
      deviceType,
      filterClearAll,
      filterEditTopLink,
      filterTopLink,
      accountText,
      dataTopUp,
      wirelessDescriptionText,
    },
    serviceNumbersPlanDetails,
    onChangeCheckBox,
    wirelessCheckAll,
    wirelessCheckboxVal,
    searchWirelessSelectedOption,
    onSearchWirelessFieldChange,
    searchTextChange,
    searchText,
    wirelessDropDownOptions,
    pageChangeHandler,
    currentPage,
    isWirelessPlanModalOpen,
    bulkWirelessModalOpen,
    bulkWirelessModalClose,
    sorting,
    sortingClick,
    moveWirelessPlan,
    onBulkWirelessChangeDropDown,
    bulkWirelessDeviceValue,
    bulkActionsApply,
    wirelessCheckboxStatus,
    serviceNumbersWithFlag,
    currentPlanList,
    currentDevicesList,
    onWirelessAllChangeCheckBox,
    dataTopUpDropDownValue,
    moveAddOnDetails,
    showDataUploadDropDown,
  } = props;

  const [filterOpen, setFilterOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterClearAllStatus, setFilterClearAllStatus] = useState(false);
  const [totalRecords, setTotalRecords] = useState(serviceNumbersPlanDetails.length);
  const [planSearchText, setPlanSearchText] = useState('');
  const [filterSearchedResults, setFilterSearchedResults] = useState([]);

  const [pageSize, setPageSize] = useState(parseInt(paginationBaseNumber, 10));
  const pageSizeOptions = paginationNumbers.split(',');
  const numberOfPages = filterApplied ? Math.ceil(totalRecords / pageSize) : Math.ceil(serviceNumbersPlanDetails.length / pageSize);

  const wirelessDropDownOptionsVal = prepareDropDownOptionsArry(wirelessDropDownOptions);
  const searchFieldsDropDownOptions = prepareDropDownOptionsArry(wirelessSearchFields.options);
  const dataTopUpDropDownOptionsVal = dataTopUpPlans.options;
  const dataTopUpDropDownOptions = prepareDropDownOptionsArry(dataTopUpDropDownOptionsVal);

  const onPageChange = (pageNumber) => {
    pageChangeHandler(pageNumber, 'wireless-table-section-amp');
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setTimeout(() => {
      const lastTableRow = document.getElementById('wireless-details-table').lastElementChild.lastElementChild;
      lastTableRow.scrollIntoView();
    }, 200);
  };

  const getSearchSelectionValue = (searchKey) => {
    const option = wirelessSearchFields.options.find(item => item.key === searchKey);
    const defaultOption = wirelessSearchFields.options.find(item => item.key === 'nosearch');
    if (option) {
      return option.value;
    }
    return defaultOption.value;
  };

  const movePlan = (event, number) => {
    const selectedValue = event.target.getAttribute('data-item');
    moveWirelessPlan(selectedValue, number);
  };

  const getNewDataValue = (deviceKey) => {
    const option = dataTopUpPlans.options.find(item => item.key === deviceKey);
    const defaultOption = dataTopUpPlans.options.find(item => item.key === 'topUpSmall');
    if (option) {
      return option.value;
    }
    return defaultOption.value;
  };


  const getNewDeviceValue = (deviceKey) => {
    const option = wirelessDropdownFields.options.find(item => item.key === deviceKey);
    const defaultOption = wirelessDropdownFields.options.find(item => item.key === 'removePlan');
    if (option) {
      return option.value;
    }
    return defaultOption.value;
  };

  const totalPlanSelected = () => {
    if (filterApplied && planSearchText.length > 0) {
      return Object.entries(wirelessCheckboxVal)
        .filter(itm => filterSearchedResults.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
          && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
    } else if (filterApplied) {
      return Object.entries(wirelessCheckboxVal)
        .filter(itm => filteredData.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
          && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
    }
    return Object.entries(wirelessCheckboxVal)
      .filter(itm => serviceNumbersPlanDetails.find(serviceItem => serviceItem.serviceNumber === itm[0]) !== undefined
        && itm[0].planName !== 'unaddressableServices' && itm[1] !== false).length;
  };

  const bulkApplyOnSelectedItems = () => {
    if (wirelessCheckAll) {
      if (filterApplied && planSearchText.length > 0) {
        const selectedNumbers = filterSearchedResults.filter(serviceItem => wirelessCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        bulkActionsApply(selectedNumbers);
      } else if (filterApplied) {
        const selectedNumbers = filteredData.filter(serviceItem => wirelessCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        bulkActionsApply(selectedNumbers);
      } else {
        const selectedNumbers = serviceNumbersPlanDetails.filter(serviceItem => wirelessCheckboxVal[serviceItem.serviceNumber] === true)
          .map(serviceItem => serviceItem.serviceNumber);
        bulkActionsApply(selectedNumbers);
      }
    } else {
      const selectedNumbers = serviceNumbersPlanDetails.filter(serviceItem => wirelessCheckboxVal[serviceItem.serviceNumber] === true)
        .map(serviceItem => serviceItem.serviceNumber);
      bulkActionsApply(selectedNumbers);
    }
  };

  const onSearchText = () => {
    if (filterApplied) {
      return planSearchText;
    }
    return searchText;
  };

  const onSearchTextChange = (event) => {
    const filterSearchText = event.target.value;
    setPlanSearchText(filterSearchText);
    if (filterApplied) {
      let filterResults = [];
      if (searchWirelessSelectedOption === 'number') {
        filterResults = filteredData.filter(numbers => numbers.serviceNumber.includes(filterSearchText));
      } else if (searchWirelessSelectedOption === 'username') {
        filterResults = filteredData.filter(numbers => numbers.userName.toLowerCase().includes(filterSearchText.toLowerCase()));
      } else if (searchWirelessSelectedOption === 'nosearch') {
        filterResults = filteredData;
        setPlanSearchText('');
      }
      onPageChange(0);
      setTotalRecords(filterResults.length);
      setFilterSearchedResults(filterResults);
    } else {
      searchTextChange(event);
    }
  };

  const onSearchDropDownChange = (event) => {
    if (filterApplied) {
      setPlanSearchText('');
      setFilterSearchedResults(filteredData);
      setTotalRecords(filteredData.length);
      onSearchWirelessFieldChange(event);
    } else {
      onSearchWirelessFieldChange(event);
    }
  };

  const applyFilterOnFullData = (filterObj) => {
    let filterResults = serviceNumbersPlanDetails;

    if (filterObj.fiveGCheck) {
      filterResults = filterResults.filter(itm => itm.fiveGInteraction === '1');
    }
    if (filterObj.voiceCheck) {
      filterResults = filterResults.filter(itm => serviceNumbersWithFlag[itm.serviceNumber].dataOnly === false);
    }
    if (filterObj.dataCheck) {
      filterResults = filterResults.filter(itm => serviceNumbersWithFlag[itm.serviceNumber].dataOnly === true);
    }
    if (filterObj.currentPlanSelected.length > 0) {
      let currentPlanResults = [];
      filterObj.currentPlanSelected.forEach((plan) => {
        const planResults = filterResults.filter(itm => itm.currentPlan.toLowerCase() === plan.toLowerCase());
        currentPlanResults = [...currentPlanResults, ...planResults];
      });
      filterResults = [...currentPlanResults];
    }
    if (filterObj.currentDeviceValues.length > 0) {
      let currentDeviceResults = [];
      filterObj.currentDeviceValues.forEach((dev) => {
        const deviceResults = filterResults.filter(itm => itm.deviceType.toLowerCase() === dev.toLowerCase());
        currentDeviceResults = [...currentDeviceResults, ...deviceResults];
      });
      filterResults = [...currentDeviceResults];
    }

    onPageChange(0);
    setPlanSearchText('');
    setFilterApplied(true);
    setFilteredData(filterResults);
    setFilterOpen(false);
    setFilterClearAllStatus(false);
    setTotalRecords(filterResults.length);
  };

  const clearFilterApplied = () => {
    setFilterApplied(false);
    setFilterOpen(false);
    setFilterClearAllStatus(true);
  };

  const cancelFilter = () => {
    setFilterApplied(false);
    setFilterOpen(false);
    setFilterClearAllStatus(false);
  };

  const getDataRows = () => {
    if (filterApplied && planSearchText.length > 0) {
      return filterSearchedResults;
    } else if (filterApplied) {
      return filteredData;
    }
    return serviceNumbersPlanDetails;
  };

  const onChangeAllCheckBox = (event) => {
    if (filterApplied) {
      onWirelessAllChangeCheckBox(event, filteredData);
    } else {
      onWirelessAllChangeCheckBox(event, serviceNumbersPlanDetails);
    }
  };

  const getTotalRecords = () => (filterApplied ? totalRecords : serviceNumbersPlanDetails.length);

  const rowData = dataTable => dataTable.slice(currentPage * pageSize, pageSize * (currentPage + 1)).map(service => (
    <tr key={`${service.serviceNumber}`}>
      <td className="sticky-col">
        {service.dataOnly === true &&
          <div className="table-item-text ri-flex-pill-width inline">
            <SvgIcon name="icon-authentication-hotspot" className="mobile-pill-icon" />
          </div>
        }
        {service.dataOnly === false &&
          <div className="table-item-text ri-flex-pill-width inline">
            <SvgIcon name="icon-mobiles-mobile" className="mobile-pill-icon" />
          </div>
        }
      </td>
      <td className="sticky-col1">
        {service.suggestedPlanName !== 'unaddressableServices' &&
          <div className="table-item-text ri-flex-service-width inline">
            <Checkbox
              id={`${service.serviceNumber}-wirelessService`}
              onChange={onChangeCheckBox}
              checked={wirelessCheckboxVal[service.serviceNumber]}
              label={formatPhoneNumber(service.serviceNumber)}
            />
            {service.fiveGInteraction === '1' &&
              <div className="p-2 table-item-text ri-flex-pill-width inline">
                <SvgIcon name="icon-bill-5g" className="mobile-pill-icon" />
              </div>
            }
            {service.fiveGInteraction !== '1' &&
              <div className="p-2 table-item-text ri-flex-pill-width-not-5g inline">
                <SvgIcon name="icon-system-circle-filled" className="mobile-pill-icon" />
              </div>
            }
          </div>
        }
      </td>
      <td><div className="table-item-text">{service.userName}</div></td>
      <td><div className="table-item-text">{service.currentPlan}</div></td>
      <td><div className="table-item-text">{service.currentPlanCost}</div></td>
      <td>
        <div className="table-item-text">{service.dataUsage}{gbText} <br />
          <span className="trade-in-note">({service.dataAllowance}{gbText})</span>
        </div>
      </td>
      <td>
        <div className="new-device-selection table-item-text">
          <Dropdown
            value={getNewDeviceValue(serviceNumbersWithFlag[service.serviceNumber].planName)}
            dropdownId={`${service.serviceNumber}-wireless-dropdown`}
            options={wirelessDropDownOptionsVal}
            onOptionClick={e => movePlan(e, service.serviceNumber)}
          />
        </div>
      </td>
      <td><div className="table-item-text">{service.deviceType}</div></td>
      <td>
        <div className="table-item-text">
          {service.accountNumber}
        </div>
      </td>
      <td>
        <div className="new-device-selection table-item-text">
          {showDataUploadDropDown[service.serviceNumber] === true
          &&
            <Dropdown
                value={getNewDataValue(dataTopUpDropDownValue[service.serviceNumber])}
                dropdownId={`${service.serviceNumber}-dataTopUp-dropdown`}
                options={dataTopUpDropDownOptions}
                onOptionClick={moveAddOnDetails}
            />
          }
        </div>
      </td>
    </tr>
  ));

  return (
    <div id="wireless-table-section-amp" className="wireless-table-section-amp">
      <div className="wireless-table">
        <div className="row">
          <div className="col-12 table-info-text">
            {wirelessDescriptionText}
          </div>
        </div>
        <div className="row table-nav">
          <div className="col-2 table-action items">
            {totalPlanSelected()} {itemSelectedText}
          </div>
          <div className="col-2 table-action">
            <Button
              variant="primary"
              onClick={bulkWirelessModalOpen}
              size="medium"
              disabled={!wirelessCheckboxStatus && !wirelessCheckAll}
            >
              {bulkActionText}
            </Button>
          </div>
          <div className="col-3 search-field-option">
            {(filterOpen === false) &&
              <Dropdown
                value={getSearchSelectionValue(searchWirelessSelectedOption)}
                dropdownId="search-plan-field-option"
                options={searchFieldsDropDownOptions}
                onOptionClick={onSearchDropDownChange}
                className="search-field-option-container"
              />
            }
          </div>
          <div className="col-2 search-field-option-text">
            {(filterOpen === false) &&
              <TextInput
                name="trade-search-text"
                onChange={onSearchTextChange}
                placeholder={wirelessSearchFields.placeholder}
                value={onSearchText()}
              />
            }
          </div>
          <div className="col-1 table-action">
            {filterApplied &&
              <Button
                variant="primary"
                onClick={() => clearFilterApplied()}
                size="medium"
              >
                {filterClearAll}
              </Button>
            }
          </div>
          <div className="col-1 offset-1 table-action filter-button">
            <SvgIcon name="icon-product-filter" className="icon-filter" />
            <Button
              variant="secondary"
              size="medium"
              state="app"
              className="filter-button"
              onClick={() => setFilterOpen(!filterOpen)}
            > {filterApplied ? filterEditTopLink : filterTopLink}</Button>
          </div>
          <div className="col-12">
            <WirelessFilters
              authorableContent={authorableContent}
              currentPlanList={currentPlanList}
              currentDevicesList={currentDevicesList}
              filterOpen={filterOpen}
              applyFilter={applyFilterOnFullData}
              cancelFilter={cancelFilter}
              filterClearAll={filterClearAllStatus}
              filterApplied={filterApplied}
            />
          </div>
        </div>
        <div id="wireless-table-section-amp" className="wireless-table-section-amp row">
          <div className="sticky-wrapper col-12">
            <div className="sticky-scroller">
              <table className="sticky-table" id="wireless-details-table">
                <thead>
                  <tr>
                    <th className="sticky-col">&nbsp;</th>
                    <th className="sticky-col1">
                      <div className="table-title">
                        <Checkbox
                          id="all-wirelessService"
                          onChange={e => onChangeAllCheckBox(e)}
                          checked={getTotalRecords() > 0 && getTotalRecords() === totalPlanSelected()}
                          label="Service Number"
                        />
                        {sorting.numberSortType === 'ASC' &&
                          <div
                            className="number-sort-asc"
                            onClick={() => sortingClick('number', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.numberSortType === 'DESC' &&
                          <div
                            className="number-sort-desc"
                            onClick={() => sortingClick('number', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-elarge-width">
                        {username}
                        {sorting.userSortType === 'ASC' &&
                          <div
                            className="user-sort-asc"
                            onClick={() => sortingClick('userName', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.userSortType === 'DESC' &&
                          <div
                            className="user-sort-desc"
                            onClick={() => sortingClick('userName', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-elarge-width">
                        {currentPlanName}
                        {sorting.currentPlanNameSortType === 'ASC' &&
                          <div
                            className="current-plan-name-sort-asc"
                            onClick={() => sortingClick('currentPlanName', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.currentPlanNameSortType === 'DESC' &&
                          <div
                            className="current-plan-name-sort-desc"
                            onClick={() => sortingClick('currentPlanName', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-small-width">
                        {cost}
                        {sorting.currentPlanCostSortType === 'ASC' &&
                          <div
                            className="current-plan-cost-sort-asc"
                            onClick={() => sortingClick('currentPlanCost', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.currentPlanCostSortType === 'DESC' &&
                          <div
                            className="current-plan-cost-sort-desc"
                            onClick={() => sortingClick('currentPlanCost', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th>
                      <div className="table-title ri-flex-large-width">
                        {data} <br /> {dataAllowanceConsume}
                        {sorting.dataUsageSortType === 'ASC' &&
                          <div
                            className="data-usage-sort-asc"
                            onClick={() => sortingClick('dataUsage', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.dataUsageSortType === 'DESC' &&
                          <div
                            className="data-usage-sort-desc"
                            onClick={() => sortingClick('dataUsage', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th><div className="table-title ri-flex-xlarge-width">{planRecommendation}</div></th>
                    <th>
                      <div className="table-title ri-flex-elarge-width">
                        {deviceType}
                        {sorting.deviceSortType === 'ASC' &&
                          <div
                            className="device-sort-asc"
                            onClick={() => sortingClick('deviceType', 'DESC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                        {sorting.deviceSortType === 'DESC' &&
                          <div
                            className="device-sort-desc"
                            onClick={() => sortingClick('deviceType', 'ASC')}
                            role="button"
                            tabIndex="0"
                          />
                        }
                      </div>
                    </th>
                    <th><div className="table-title ri-flex-large-width">{accountText}</div></th>
                    <th><div className="table-title ri-flex-xlarge-width">{dataTopUp}</div></th>
                  </tr>
                </thead>
                <tbody>
                  {rowData(getDataRows())}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        pages={numberOfPages}
        pageSize={pageSize}
        pageSizeOptions={pageSizeOptions}
        totalRecordLength={filterApplied ? totalRecords : serviceNumbersPlanDetails.length}
        restorePageNumber={0}
        page={currentPage}
        canNext={(currentPage < numberOfPages - 1)}
        canPrevious={currentPage !== 0}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />

      <Modal
        isOpen={isWirelessPlanModalOpen}
        onShowModal={bulkWirelessModalClose}
        size="large"
        className="bulk-tradein-modal"
      >
        <Modal.Header>{bulkActionText}</Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              {bulkUpgradeTextPrefix} {totalPlanSelected()} {bulkPlanUpgradeTextSuffix}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <Dropdown
                value={getNewDeviceValue(bulkWirelessDeviceValue)}
                dropdownId="bulk-plan-dropdown"
                options={wirelessDropDownOptionsVal}
                onOptionClick={onBulkWirelessChangeDropDown}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            size="xSmall"
            onClick={bulkWirelessModalClose}
          >{bulkCancelText}</Button>
          <Button
            variant="super"
            size="medium"
            state="app"
            onClick={() => bulkApplyOnSelectedItems()}
          >{bulkUpgradeText}</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WirelessTable;
